import React, { Component } from "react";
import Editor from "./editor/Editor";
import MinNav from "./component/MinNav";

class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = { privacy: "" };
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}others/privacy`)
      .then(res => res.json())
      .then(data => {
        this.setState({ privacy: data.privacy });
      });
  }

  render() {
    return (
      <div className="a-container">
        <MinNav />
        <Editor
          apiROOT={this.props.apiROOT}
          root={this.props.root}
          page="privacy"
          post={this.state.privacy}
        />
      </div>
    );
  }
}

export default Privacy;
